import React from "react";
import styled from "styled-components";
import _ from "lodash";

export const StyledTD = ({ content }) => {
  return (
    <ToolTip>
      {content && content.split(' ')[0].length > 15 ? (
        <div className="tooltip-text">{content}</div>
      ) : null}
      {content}
    </ToolTip>
  );
};

const ToolTip = styled.td`
  overflow: hidden;
  text-overflow: ellipsis;

  .tooltip-text {
    visibility: hidden;
    width: fit-content;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 5px;

    /* Position the tooltip text */
    position: absolute;
    z-index: 1;
  }

  &:hover .tooltip-text {
    visibility: visible;
  }
`;
